/* eslint-disable import/prefer-default-export */
export const groupBy = (arr, property) => arr.reduce((memo, x) => {
    if (!memo[x[property]]) {
        memo[x[property]] = [];
    }
    memo[x[property]].push(x);
    return memo;
}, {});
